import template from './delegatedCardRequest.html';
import controller from './delegatedCardRequest.controller';
import './delegatedCardRequest.scss';

let delegatedCardRequestComponent = {
  restrict: 'E',
  bindings: {
    employeeProfile: '<',
    cards: '<',
  },
  template,
  controller,
};

export default delegatedCardRequestComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequest/delegatedCardRequest.component.js